import * as React from 'react';
import { connect } from 'react-redux';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import * as Features from '../../../shared/Features';
import { Translate } from '../../../shared/LanguageService';
import SinglePhotographerInvoicePage from './photographer/SinglePhotographerInvoicePage';
import MultiplePhotographersInvoicePage from './photographers/MultiplePhotographersInvoicePage';

interface IProps {
    user: any;
}

interface IState {
    activeTab: number;
}

class PhotographerInvoicePage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            activeTab: 1
        };

        this.handleTabChange = this.handleTabChange.bind(this);
    }

    handleTabChange(key: React.SyntheticEvent) {
        this.setState({ activeTab: key });
    }

    render() {
        return (
            <div>
                {Features.hasFeature(Features.ViewAllPhotographerInvoices, this.props.user) && (
                    <Tab.Container
                        activeKey={this.state.activeTab}
                        onSelect={this.handleTabChange}
                        id="uncontrolled-tab"
                    >
                        <div>
                            <Nav className="nav-tabs">
                                <NavItem eventKey={1}>
                                    {Translate(
                                        'photographer-invoice/tab/multiple-photographers/title'
                                    )}
                                </NavItem>
                                <NavItem eventKey={2}>
                                    {Translate(
                                        'photographer-invoice/tab/single-photographer/title'
                                    )}
                                </NavItem>
                                <NavItem eventKey={3}>
                                    {Translate(
                                        'photographer-invoice/tab/single-employed-photographer/title'
                                    )}
                                </NavItem>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey={1}>
                                    <fieldset>
                                        <legend>
                                            {Translate(
                                                'photographer-invoice/tab/multiple-photographers/legend'
                                            )}
                                        </legend>
                                        {this.state.activeTab === 1 && (
                                            <MultiplePhotographersInvoicePage />
                                        )}
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={2}>
                                    <fieldset>
                                        <legend>
                                            {Translate(
                                                'photographer-invoice/tab/single-photographer/legend'
                                            )}
                                        </legend>
                                        {this.state.activeTab === 2 && (
                                            <SinglePhotographerInvoicePage
                                                employedPhotographers={false}
                                            />
                                        )}
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={3}>
                                    <fieldset>
                                        <legend>
                                            {Translate(
                                                'photographer-invoice/tab/single-employed-photographer/legend'
                                            )}
                                        </legend>
                                        {this.state.activeTab === 3 && (
                                            <SinglePhotographerInvoicePage
                                                employedPhotographers={true}
                                            />
                                        )}
                                    </fieldset>
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                )}

                {!Features.hasFeature(Features.ViewAllPhotographerInvoices, this.props.user) &&
                    Features.hasFeature(Features.ViewOwnPhotographerInvoices, this.props.user) && (
                        <SinglePhotographerInvoicePage
                            employedPhotographers={this.props.user.details.employedBySE360}
                        />
                    )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(withRouter(PhotographerInvoicePage));
